<template>
  <footer class="bg-dark-blue text-white">
    <div
        class="flex flex-wrap lg:flex-nowrap items-center justify-center lg:justify-between max-w-7xl mx-auto py-14 px-4 lg:px-10">
      <div class="lg:order-3 flex-shrink-0">
        <div class="flex items-center justify-center mb-4">
          <a href="https://www.linkedin.com/company/talents-et-carriere/" target="_blank" rel="noopener noreferrer">
            <img src="/images/linkedin.svg" alt="Logo LinkedIn">
          </a>
        </div>
        <a href="http://www.talents-carriere.fr" target="_blank" class="text-lg">www.talents-carriere.fr</a>
      </div>
      <div
          class="flex flex-col lg:flex-row items-center lg:justify-center text-sm uppercase lg:order-2 mt-4 lg:mt-0 w-full">
        <ul class="text-center lg:text-left lg:border-r lg:border-l border-gray-600 px-12 mb-4 lg:mb-0">
          <li class="my-2">
            <nav-link :href="route('home')" anchor="#how-it-works" :same-page="home" :smooth-scroll="home"
                      :footer="true">
              {{ $trans('app.menu.how-it-works') }}
            </nav-link>
          </li>
          <li class="my-2">
            <nav-link :href="route('home')" anchor="#what-is-it" :same-page="home" :smooth-scroll="home" :footer="true">
              {{ $trans('app.menu.what-is-it') }}
            </nav-link>
          </li>
          <li class="my-2">
            <nav-link :href="route('home')" anchor="#pricing" :same-page="home" :smooth-scroll="home" :footer="true">
              {{ $trans('app.menu.pricing') }}
            </nav-link>
          </li>
          <li class="my-2">
            <nav-link :href="route('home')" anchor="#testimonials" :same-page="home" :smooth-scroll="home"
                      :footer="true">
              {{ $trans('app.menu.testimonials') }}
            </nav-link>
          </li>
        </ul>
        <ul class="text-center lg:text-left lg:border-r border-gray-600 px-12">
          <li class="my-2">
            <nav-link :href="route('contact')" :footer="true">
              {{ $trans('app.menu.contact') }}
            </nav-link>
          </li>
          <li class="my-2">
            <a href="http://www.talents-carriere.fr/mentions-legales"
               target="_blank"
               class="inline-flex uppercase items-center text-sm font-medium leading-5 transition duration-150 ease-in-out"
            >
              {{ $trans('app.menu.legal-terms') }}
            </a>
          </li>
          <li class="my-2">
            <a href="https://www.talents-carriere.fr/politique-de-confidentialite/"
               target="_blank"
               class="inline-flex uppercase items-center text-sm font-medium leading-5 transition duration-150 ease-in-out"
            >
              {{ $trans('app.menu.privacy-policy') }}
            </a>
          </li>
        </ul>
      </div>
      <div class="lg:order-1 mt-8 lg:mt-0 text-center lg:text-left">
        <img src="/images/logo-white.svg" alt="Logo Talents & Carriere" class="mx-auto lg:mx-0">
        <p class="leading-4 mt-6">
          Talents & Carrière<br>
          Test AGEM® - {{ $trans('app.menu.discover-agem') }}.
        </p>
      </div>
    </div>
  </footer>
</template>

<script>
import NavLink from '@/Components/NavLink'

export default {
  components: {NavLink},
  props: {
    home: {}
  }


}
</script>

<style>

</style>
